module.exports = __webpack_public_path__ + "media/lsd.bf802fbc.wav";